import {PrivateCommand} from "../PrivateCommand";
import cmp from "../../../context/context";
import {CMPInfo} from "../../model/c-m-p-info";
import {TCString} from "../../../tcstring/t-c-string";

export class GetCMPInfo extends PrivateCommand {
    /* STATIC */

    /* INSTANCE */
    public override execute(option?: string, callback?: Function) {
        if (callback && cmp().tcString) {
            const info: CMPInfo = CMPInfo.build(cmp().tcString as TCString);
            callback(info.data);
        }
    }
}
